import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

var screenWidth = window.innerWidth;
var main = document.getElementById('main');
var mainNav = document.getElementById('mainNav');
var darkNav = document.body.classList.contains('darkNav');
var tl, navColor;

navColor = '#161E0F';
// if (darkNav) {
//   navColor = '#161E0F';
// } else {
//   navColor = '#FDFAF7';
// }

//init
if (screenWidth >= 1280) {
  setupFixedNav();
}

// if (!darkNav) {
//   var hoverElements = mainNav.querySelectorAll('.dynamicHoverColor');
//   hoverElements.forEach((el) => {
//     el.classList.add('cursorCircleDark');
//   });

//   // if dark nav - add dark hover class to each element
//   var menuElements = mainNav.querySelectorAll('.menu-item');
//   menuElements.forEach((el) => {
//     var children = el.childNodes;
//     children.forEach(function (item) {
//       if (item.classList) {
//         item.classList.add('cursorCircleDark');
//       }
//     });
//   });
// }

//if start mobile/attach after
window.addEventListener('resize', reportWindowSize);
function reportWindowSize() {
  screenWidth = window.innerWidth;
  if (screenWidth >= 1280) {
    setupFixedNav();
  }
}

function setupFixedNav() {
  tl = gsap.timeline({
    scrollTrigger: {
      markers: false,
      trigger: main,
      pin: false,
      start: '50px top',
      end: '50px top',
      onEnterBack: function () {
        tl.reverse();
      },
    },
  });

  tl.addLabel('start').to(
    mainNav,
    {
      duration: 0.8,
      height: 70,
      backgroundColor: navColor,
    },
    0
  );
}
